// extracted by mini-css-extract-plugin
export default {"navigation":"HeaderNavigation_navigation__tOHM6","link":"HeaderNavigation_link__H309N","activeLink":"HeaderNavigation_activeLink__hxfAh"};